import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Employee } from '../interfaces/employee.interface';
import { EmployeeService } from "../services/employee";
import { RouterLink,  Router} from '@angular/router';
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule, FormGroup, FormBuilder  } from '@angular/forms';

@Component({
  selector: 'app-employee',
  imports: [RouterLink, FormsModule, ReactiveFormsModule, DatePipe],
  templateUrl: './employee.html',
  styleUrl: './employee.css'
})


export class EmployeeComponent {
  public employees: Employee[] = [];
  myForm: FormGroup;

  constructor( 
    private employeeService: EmployeeService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({

              });
    this.getEmployees();
  }

public async getEmployees(): Promise<void> {
 
    try {
    this.employees = await this.employeeService.getEmployees();
    this.cdr.detectChanges();
    } catch (error) {
      console.error('getEmployees error',error);
    }
    
  }

  async deleteEmployee(employee: Employee): Promise<void>{
    const confirmation = window.confirm(`Are you sure you want to delete ${employee.fname + " " + employee.lname}?`);
    if (!confirmation) {
       return;
    }
    try
    {
           await this.employeeService.deleteEmployee(employee.id);
            this.getEmployees();
            this.cdr.detectChanges();
            this.router.navigateByUrl('employee')
 
    } catch (error) {
           console.error('deleteemployee error',error);
    }
  }

  onEdit(employee: Employee): void {
     this.employeeService.selectedEmployee = employee;
    this.router.navigateByUrl('editemployee')
  }

}
